import { RoleType } from "./api/client";
import { ADMIN_ROLES } from "./core/consts/roles";
import { concatCanActivateFn } from "./core/functions/concat-guards";
import { msalCanActivateFn } from "./core/guards/msal.guard";
import { anyRoleGuard, roleGuard } from "./core/guards/role.guard";
import { AppRoutes } from "./core/models/app-route.model";
import { MainDashboardComponent } from "./main-dashboard/main-dashboard.component";

export const APP_ROUTES: AppRoutes = [
  {
    path: "unauthorized",
    title: "Unauthorized",
    loadComponent: () => import("./core/unauthorized/unauthorized.component").then((c) => c.UnauthorizedComponent),
  },
  {
    path: "",
    title: "SIBase X",
    loadComponent: () => import("./core/layouts/main-layout/main-layout.component").then((c) => c.MainLayoutComponent),
    canActivate: [concatCanActivateFn(msalCanActivateFn, roleGuard(RoleType.Sibasex_user))],
    pathMatch: "prefix",
    loadChildren: (): AppRoutes => [
      {
        path: "i-base-management",
        loadChildren: () => import("./i-base-management/i-base-management.routes").then((r) => r.I_BASE_MANAGEMENT_ROUTES),
      },
      {
        path: "facilities-and-contacts",
        loadChildren: () => import("./facilities-and-contacts/facilities-and-contacts.routes").then((r) => r.FACILITIES_AND_CONTACTS_ROUTES),
      },
      {
        path: "admin",
        canActivate: [anyRoleGuard(...ADMIN_ROLES)],
        loadChildren: () => import("./admin/admin.routes").then((r) => r.ADMIN_ROUTES_ROUTES),
      },
      {
        path: "",
        component: MainDashboardComponent,
      },
    ],
  },
  {
    path: "**",
    redirectTo: "/",
  },
];
